"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSendEnquiryDocumentsResponseDataDto = instanceOfSendEnquiryDocumentsResponseDataDto;
exports.SendEnquiryDocumentsResponseDataDtoFromJSON = SendEnquiryDocumentsResponseDataDtoFromJSON;
exports.SendEnquiryDocumentsResponseDataDtoFromJSONTyped = SendEnquiryDocumentsResponseDataDtoFromJSONTyped;
exports.SendEnquiryDocumentsResponseDataDtoToJSON = SendEnquiryDocumentsResponseDataDtoToJSON;
exports.SendEnquiryDocumentsResponseDataDtoToJSONTyped = SendEnquiryDocumentsResponseDataDtoToJSONTyped;
/**
 * Check if a given object implements the SendEnquiryDocumentsResponseDataDto interface.
 */
function instanceOfSendEnquiryDocumentsResponseDataDto(value) {
    if (!('success' in value) || value['success'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function SendEnquiryDocumentsResponseDataDtoFromJSON(json) {
    return SendEnquiryDocumentsResponseDataDtoFromJSONTyped(json, false);
}
function SendEnquiryDocumentsResponseDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'success': json['success'],
        'message': json['message'],
    };
}
function SendEnquiryDocumentsResponseDataDtoToJSON(json) {
    return SendEnquiryDocumentsResponseDataDtoToJSONTyped(json, false);
}
function SendEnquiryDocumentsResponseDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'success': value['success'],
        'message': value['message'],
    };
}
